import lunr from "/home/runner/work/deriv-api-docs/deriv-api-docs/node_modules/lunr/lunr.js";
export const language = ["en"];
export const removeDefaultStopWordFilter = false;
export const removeDefaultStemmer = false;
export const Mark = null;
export const searchIndexUrl = "search-index{dir}.json";
export const searchResultLimits = 8;
export const searchResultContextMaxLength = 50;
export const explicitSearchResultPath = false;
export const searchBarShortcut = true;
export const searchBarShortcutHint = true;
export const searchBarPosition = "right";
export const docsPluginIdForPreferredVersion = undefined;
export const indexDocs = true;
export const searchContextByPaths = null;
export const hideSearchBarWithNoSearchContext = false;
export const useAllContextsWithNoSearchContext = false;